module.exports = __webpack_public_path__ + "static/img/multipla-escolha.04b25a5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/multipla-escolha.png
// module id = vNRU
// module chunks = 1